export default {
  apiKey: 'AIzaSyAfZG8hmbzAms-TbHz_zEfUZv2dT2RCYpU',
  authDomain: 'transglobe-34b7c.firebaseapp.com',
  databaseURL: 'https://transglobe-34b7c.firebaseio.com',
  projectId: 'transglobe-34b7c',
  storageBucket: 'transglobe-34b7c.appspot.com',
  messagingSenderId: '302816261063',
  appId: '1:302816261063:web:12442cc61473bcff955fe2',
};
